// Shared diagnostics buffer for the Genesys messenger conversation-start flow.
//
// The view (MessengerView), the SDK service (genesysService) and the Vuex store
// all write into this single timeline so a conversation-start log captures the
// full ordered sequence of UI steps, SDK lifecycle events and send attempts —
// not just the handful of steps visible inside onConversationStart.
//
// It is intentionally a module-level singleton (not tied to the GenesysService
// instance, which gets nulled/recreated): the buffer must survive across re-inits.

var MAX_ENTRIES = 300

var startTime = Date.now()
var entries = []

// Begins a fresh diagnostics window. Call at the start of a conversation-start
// attempt so timestamps are relative to that attempt.
function reset() {
  startTime = Date.now()
  entries = []
}

// Records a diagnostic entry. `tag` identifies the source (e.g. 'view', 'svc',
// 'store'); `msg` is a short human-readable description. Caps the buffer so a
// long-lived session can never grow it unbounded.
function log(tag, msg) {
  var entry = '[+' + (Date.now() - startTime) + 'ms] ' + tag + ': ' + msg
  entries.push(entry)
  if (entries.length > MAX_ENTRIES) {
    entries = entries.slice(entries.length - MAX_ENTRIES)
  }
  // Mirror to the console so local development still sees a unified stream.
  if (typeof console !== 'undefined' && console.log) {
    console.log(entry)
  }
  return entry
}

// Returns the full timeline as a single newline-joined string for posting to
// api/messenger/log.
function dump() {
  return entries.join('\n')
}

export default { reset: reset, log: log, dump: dump }
